import React from 'react'
import CrudIntegracaoListPageContainer from './CrudIntegracaoListPageContainer'

export class CrudIntegracaoListPage extends React.Component {
  render() {
    return <CrudIntegracaoListPageContainer {...this.props} />
  }
}
